import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import TableContainerSearch from "../../Components/Common/TableContainerSearch";
import TableContainer1 from "../../Components/Common/TableContainer1";
import axios from "axios";
import exportToPDF from "../../Components/Common/exportToPDF";
import exportToExcel from "../../Components/Common/exportToExcel";
import { showToast } from "../../Components/ToastNotification";
import { shareEmailReportThunk } from "../../slices/shareEmailReport/thunk";
import { useDispatch } from "react-redux";
import CommonLoading from "../../Components/Common/CommonLoading";
import TableContainerSearchHoldings from "../../Components/Common/TableContainerSearchHoldings";

const IncludeMTF = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const { userData } = usePersistStoreData();
  const dispatch = useDispatch();
  // console.log("userData", userData);
  const token = userData?.token;

  const [rightColumn, setRightColumn] = useState(true);
  const toggleRightColumn = () => {
    setRightColumn(!rightColumn);
  };

  const [isTopPageDropdown, setTopPageDropdown] = useState(false);
  const toggleDropdown = () => {
    setTopPageDropdown(!isTopPageDropdown);
  };

  const columns = useMemo(
    () => [
      {
        id: "scrip_name",
        Header: "Scrip Name",
        accessorKey: "scrip_name",
        
        meta: {
          style: {  wordBreak: "break-word", minWidth:"18rem" }
        }
      },
      {
        id: "stock_shares",
        Header: "Stock Shares",
        accessorKey: "stock_shares",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "pledge_stock",
        Header: "Pledge Stocks",
        accessorKey: "pledge_stock",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "mtf_collateral",
        Header: "MTF Collateral",
        accessorKey: "mtf_collateral",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "mtf_pledge",
        Header: "MTF Pledge",
        accessorKey: "mtf_pledge",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "dp_holding",
        Header: "DP Holdings",
        accessorKey: "dp_holding",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "total_holding",
        Header: "Total Holdings",
        accessorKey: "total_holding",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "buy_price",
        Header: "Buy Price (₹)",
        accessorKey: "buy_price",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "closing_price",
        Header: "Closing Rate (₹)",
        accessorKey: "closing_price",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "net_value",
        Header: "Buy Value (₹)",
        accessorKey: "net_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "current_price",
        Header: "Closing Rate (₹)",
        accessorKey: "current_price",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "current_value",
        Header: "Closing Value (₹)",
        accessorKey: "current_value",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          // console.log("row", row);
          return (
            <>
              <span class="  mb-0">
                {row?.getValue()
                  ? parseFloat(row?.getValue()).toLocaleString("en-IN")
                  : 0}{" "}
              </span>
            </>
          );
        },
      },
      {
        id: "pnl",
        Header: "Profit/Loss (₹)",
        accessorKey: "pnl",
        headerTextAlign: "end",
        bodyTextAlign: "end",
        cell: (row) => {
          const value = parseFloat(row?.getValue());
          const formattedValue = value
            ? value.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : "0.00";
          return (
            <>
            {value > 0 ? (
              <span className="text-success mb-0">
                {formattedValue}
                <i className="ms-1 ri-arrow-up-line align-middle"></i>
              </span>
            ) : value < 0 ? (
              <span className="text-danger mb-0">
                {formattedValue}
                <i className="ms-1 ri-arrow-down-line align-middle"></i>
              </span>
            ) : (
              <span className="mb-0">{formattedValue}</span>
            )}
          </>
          );
        },
      },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState(null);
  const [selectedVariance, setSelectedVariance] = useState("With");
  const [varianceLoading, setVarianceLoading] = useState("false");
  const holdingType = 1;
  const [globalFilter, setGlobalFilter] = useState("");

  const handleShareEmail = async () => {
    const body = {
      report_type: "holdings",
      "additional_data[holding_type]": "1",
    };

    try {
      const response = await dispatch(
        shareEmailReportThunk({ body, token })
      ).unwrap();

      showToast("Report sent on your email successfully", "success");
    } catch (error) {
      console.error("Error submitting request:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    const fetchHoldings = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get("holdings", {
          params: { 
            holdingType,
            //  variance: "With" 
            }, // Pass holdingType as query param
          headers: {
            Authorization: `Bearer ${userData?.token}`, // Add Authorization header
            "Content-Type": "application/json",
          },
        });

        // console.log("here", response);
        setSummary(response?.data?.summary);
        setData(response.data?.items); // Update state with fetched data
        // setTimeout(() => {
        setLoading(false);
        setVarianceLoading(false);

        // }, 2000);
      } catch (err) {
        console.error("Error fetching holdings:", err);
        setError(err);
        setLoading(false);
        setVarianceLoading(false);
      } finally {
        setLoading(false);
        setVarianceLoading(false);
      }
    };

    fetchHoldings();
  }, []); // Runs when holdingType or token changes

  const handleApplyClick = async () => {
    setVarianceLoading(true);
    try {
      const response = await axios.get("holdings", {
        params: { 
          holdingType,
          //  variance: selectedVariance
           }, // Pass holdingType as query param
        headers: {
          Authorization: `Bearer ${userData?.token}`, // Add Authorization header
          "Content-Type": "application/json",
        },
      });

      setSummary(response?.data?.summary);
      setData(response.data?.items);
      setVarianceLoading(false);
    } catch (err) {
      console.error("Error fetching holdings:", err);
      setVarianceLoading(false);
    } finally {
      setVarianceLoading(false);
    }
  };

  const tableHeaders = columns.map((col) => col.Header.replace(/₹/g, "Rs"));
  const tableBody = data.map(
    (row) =>
      columns.map((col) =>
        row[col.accessorKey]
          ? typeof row[col.accessorKey] === "string"
            ? row[col.accessorKey]
            : row[col.accessorKey].toLocaleString("en-IN")
          : 0
      ) // Default to 0 if value is missing
  );

  // Define which columns to sum
  const sumColumns = ["closing_price", "net_value", "current_value", "pnl"];
  // Example API response for totals
  const apiTotals = {
    closing_price: summary?.total_closing_price ?? 0, // Replace with actual API data
    net_value: summary?.total_net_value ?? 0,
    current_value: summary?.total_current_value ?? 0, // Replace with actual API data
    pnl: summary?.total_pnl ?? 0,
  };

  // Insert API totals
  const totals = columns.map((col, index) => {
    if (index === 0) return "TOTAL"; // First column will have "Total"

    return sumColumns.includes(col.accessorKey)
      ? apiTotals[col.accessorKey]?.toLocaleString("en-IN") || 0 // Use API total, default to 0 if missing
      : ""; // Leave other columns empty
  });

  // Add totals row to the ta
  tableBody.push(totals);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {loading ? (
            <div
              className="centerContent h-100 w-100"
              style={{ minHeight: "80vh" }}
            >
              <CommonLoading />
            </div>
          ) : (
            <Card className="mb-0">
              <CardHeader>
              <div className="m-0 p-0 d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex flex-column mb-2 mb-md-0">
                    <h3 className="m-0">Holdings (Include MTF)</h3>
                    <p className="mb-0 mt-1 fs-14 fw-medium text-muted">
                      As on Date: {summary?.as_on_date}
                    </p>
                  </div>
                  <div className="d-flex flex-wrap justify-content-start justify-content-md-center ">
                      <div className="search-box   me-2 ">
                        <input
                          id="search-bar-0"
                          type="text"
                          style={{
                            backgroundColor: "#F1F4F7",
                            paddingTop: ".6rem",
                            paddingBottom: ".6rem",
                          }}
                          className="form-control border-0 search "
                          placeholder="Search by Scrip Name"
                          value={globalFilter}
                          onChange={(e) => setGlobalFilter(e.target.value)}
                        />
                        <i className="bx bx-search-alt search-icon-new"></i>
                      </div>
                      
                  <Dropdown
                    isOpen={isTopPageDropdown}
                    toggle={toggleDropdown}
                    className={`card-header-dropdown ${
                      data?.length === 0 ? "disabled-dropdown_export" : ""
                    }`}
                  >
                    <DropdownToggle
                      tag="a"
                      className="text-reset dropdown-btn"
                      role="button"
                      color="success"
                    >
                      <Button
                        type="button"
                        color="success"
                        className="export_btn_new"
                      >
                        Export <i className="ms-1 bx bx-caret-down"></i>
                      </Button>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          exportToPDF(
                            "Holdings (Include MTF)",
                            userData,
                            ``,
                            `As on Date: ${summary?.as_on_date}`,
                            tableHeaders,
                            tableBody
                          )
                        }
                      >
                        Export as PDF
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          exportToExcel(
                            "Holdings (Include MTF)",
                            userData,
                            ``,
                            `As on Date: ${summary?.as_on_date}`,
                            tableHeaders,
                            tableBody,
                            "",
                            [],
                            []
                          )
                        }
                      >
                        Export Excel
                      </DropdownItem>
                      <DropdownItem onClick={handleShareEmail}>
                        Share on Email
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
                </div>
              </CardHeader>
              <CardBody>
                <TableContainerSearchHoldings
                  footer={false}
                  summary={summary}
                  columns={columns}
                  data={data}
                  footer2="includeMtf"
                  setSelectedVariance={setSelectedVariance}
                  selectedVariance={selectedVariance}
                  varianceLoading={varianceLoading}
                  handleApplyClick={handleApplyClick}
                  varianceType={true}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                />
              </CardBody>
            </Card>
          )}
          {/* <BreadCrumb title="Dashboard" pageTitle="Dashboards" /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IncludeMTF;
